module.exports = __webpack_public_path__ + "img/430x590px.f2bdd839.png";